"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
const charter_status_1 = require("../../model/enum/charter-status");
const cancelledBy_1 = require("../../model/enum/cancelledBy");
function getTypeofCharter(charter) {
    if (!charter.cancelled) {
        if (!charter.completed) {
            if (checkIfNeedsApproval(charter)) {
                return charter_status_1.CharterStatus.needsApproval;
            }
            else if (charter.offers &&
                charter.offers.length > 0 &&
                !charter.paymentReceived &&
                charter.offers.some(offer => !offer.status) &&
                isBeforeCharterMoment(charter)) {
                return charter_status_1.CharterStatus.pendingOffers;
            }
            else if (charter.paymentReceived && isBeforeCharterMoment(charter)) {
                return charter_status_1.CharterStatus.booked;
            }
            else if (charter.offers &&
                (charter.offers.length === 0 ||
                    (charter.offers || []).filter(offer => offer.status === 'accepted')
                        .length > 0) &&
                isBeforeCharterMoment(charter)) {
                return charter_status_1.CharterStatus.approvedPending;
            }
            else if (charter.paymentReceived && !isBeforeCharterMoment(charter)) {
                return charter_status_1.CharterStatus.completed;
            }
            else {
                return charter_status_1.CharterStatus.cancelled;
            }
        }
        else {
            return charter_status_1.CharterStatus.completed;
        }
    }
    else if (charter.cancelledBy === cancelledBy_1.CancelledBy.admin) {
        return charter_status_1.CharterStatus.cancelledByAdmin;
    }
    else if (charter.cancelledBy === cancelledBy_1.CancelledBy.owner) {
        return charter_status_1.CharterStatus.cancelledByOwner;
    }
    else if (charter.cancelledBy === cancelledBy_1.CancelledBy.renter) {
        return charter_status_1.CharterStatus.cancelledByRenter;
    }
    else {
        return charter_status_1.CharterStatus.cancelled;
    }
}
exports.getTypeofCharter = getTypeofCharter;
function checkIfNeedsApproval(charter) {
    const hasOnlyAcceptedOffer = (charter.offers || []).every(offer => offer.status) &&
        (charter.offers || []).filter(offer => offer.status === 'accepted').length >
            0;
    return (!['Available', 'Pending customer response'].includes(charter.availabilityStatus) &&
        !charter.paymentReceived &&
        (!charter.offers || charter.offers.length === 0 || hasOnlyAcceptedOffer) &&
        isBeforeCharterMoment(charter));
}
function isBeforeCharterMoment(charter) {
    const now = moment();
    const charterDateTime = moment(charter.date + ' ' + charter.charterEndTime, 'YYYY-MM-DD hh:mm:a');
    return now.isBefore(charterDateTime);
}
exports.isBeforeCharterMoment = isBeforeCharterMoment;
function getColorFromCharterStatus(status) {
    switch (status) {
        case charter_status_1.CharterStatus.needsApproval:
            return 'status-needs-approval';
        case charter_status_1.CharterStatus.pendingOffers:
            return 'status-pennding-offers';
        case charter_status_1.CharterStatus.approvedPending:
            return 'status-approved-pending';
        case charter_status_1.CharterStatus.booked:
            return 'status-booked';
        case charter_status_1.CharterStatus.completed:
            return 'status-completed';
        case charter_status_1.CharterStatus.cancelled:
        case charter_status_1.CharterStatus.cancelledByAdmin:
        case charter_status_1.CharterStatus.cancelledByOwner:
        case charter_status_1.CharterStatus.cancelledByRenter:
            return 'status-cancelled';
        default:
            return '';
    }
}
exports.getColorFromCharterStatus = getColorFromCharterStatus;
